var map = {
	"./featured-title.de-CH.json": 1140,
	"./featured-title.de-DE.json": 1141,
	"./featured-title.en-CA.json": 1142,
	"./featured-title.en-GB.json": 1143,
	"./featured-title.en-IN.json": 1144,
	"./featured-title.en-ME.json": 1145,
	"./featured-title.en-US.json": 1146,
	"./featured-title.es-EM.json": 1147,
	"./featured-title.es-ES.json": 1148,
	"./featured-title.fr-BE.json": 1149,
	"./featured-title.fr-CA.json": 1150,
	"./featured-title.fr-CH.json": 1151,
	"./featured-title.nl-BE.json": 1152,
	"./featured-title.nl-NL.json": 1153,
	"./featured-title.pl-PL.json": 1154,
	"./featured-title.pt-BR.json": 1155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1139;